document.addEventListener('click', async function(event) {
  const button = event.target.closest('[data-quick-add]');
  if (!button) return;
  event.preventDefault();
  const variantId = button.getAttribute('data-variant-id');
  if (!variantId) { window.location.href = button.getAttribute('data-product-url'); return; }
  const original = button.innerHTML;
  button.disabled = true;
  button.setAttribute('aria-label', 'Adding to cart');
  try {
    const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json','Accept':'application/json'},
      body: JSON.stringify({id: Number(variantId), quantity: 1})
    });
    if (!response.ok) throw new Error('Could not add product');
    await response.json();
    button.innerHTML = '✓';
    const count = document.querySelector('[data-cart-count]');
    if (count) {
      const cartResponse = await fetch((window.Shopify?.routes?.root || '/') + 'cart.js');
      const cart = await cartResponse.json();
      count.textContent = cart.item_count;
    }
    setTimeout(() => { button.innerHTML = original; button.disabled = false; }, 1300);
  } catch (error) {
    window.location.href = button.getAttribute('data-product-url') || '/cart';
  }
});


// Welcome offer popup: appears once per browser after 7 seconds. Shopify discount eligibility/limits must be configured in Admin.
document.addEventListener('DOMContentLoaded', function () {
  const offer = document.getElementById('WelcomeOffer');
  if (!offer) return;
  const storageKey = 'balloonStudioWelcomeOfferSeen';
  const success = offer.querySelector('.welcome-offer__success');
  const openOffer = () => { offer.classList.add('is-open'); offer.setAttribute('aria-hidden', 'false'); document.body.classList.add('offer-open'); };
  const closeOffer = () => { offer.classList.remove('is-open'); offer.setAttribute('aria-hidden', 'true'); document.body.classList.remove('offer-open'); try { sessionStorage.setItem(storageKey, '1'); } catch(e) {} };
  offer.querySelectorAll('[data-offer-close]').forEach(el => el.addEventListener('click', closeOffer));
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && offer.classList.contains('is-open')) closeOffer(); });
  const copy = offer.querySelector('[data-copy-code]');
  if (copy) copy.addEventListener('click', async () => { try { await navigator.clipboard.writeText('BALLOONS10'); copy.textContent = 'Copied!'; } catch(e) { copy.textContent = 'Code: BALLOONS10'; } });
  let seen = false; try { seen = sessionStorage.getItem(storageKey) === '1'; } catch(e) {}
  if (success) { openOffer(); try { sessionStorage.setItem(storageKey, '1'); } catch(e) {} }
  else if (!seen) window.setTimeout(openOffer, 7000);
});
